module.exports = "/assets/data/07ad5c6ea49f084e35cf257b328c0e10-L24.data.json";